import React from "react";
import { Link } from "react-router-dom";
import { API_URL, LOCATION_ID } from "..";

const ViewPurchaseOrderLayer = ({ order }) => {

  const location_id = localStorage.getItem('locationID')
  const handleConvertToBill = async () => {
    // if (!window.confirm("Are you sure you want to convert this Purchase Order into a Bill?")) return;
    try {
      const res = await fetch(`${API_URL}/api/purchase-orders/convertobill/${order.id}`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    location_id: location_id, // <-- your location id here
  }),
});

      const data = await res.json();
      if (res.ok) {
        alert("Purchase Bill created successfully!");
        // window.location.href = `/view-purchase-bill/${data.bill.id}`;
      } else {
        alert(data.message || "Failed to create bill from purchase order");
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  // ✅ Handle arrays properly
  const items = order.items || order.PurchaseOrderItems || [];
  const expenses = order.expenses || order.PurchaseOrderExpenses || [];

  // ✅ Totals
  const totalItems = items.reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const totalExpenses = expenses.reduce((sum, e) => sum + Number(e.expense_amount || 0), 0);
  const grandTotal = totalItems + totalExpenses;

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Purchase Order Details</h5>
        <Link to="/purchase-orders" className="btn btn-secondary">
          Back
        </Link>
      </div>

      <div className="card-body p-24">
        {/* 🧾 Order Info */}
        <div className="row mb-4">
          <div className="col-md-6">
            <h6 className="fw-semibold text-primary">Order Info</h6>
            <p><strong>PO Number:</strong> {order.po_number}</p>
            <p><strong>Date:</strong> {new Date(order.date).toLocaleDateString()}</p>
            <p>
              <strong>Status:</strong>{" "}
              <span className={`badge bg-${order.status === "Completed" ? "success" : "warning"}`}>
                {order.status}
              </span>
            </p>
            {order.remarks && <p><strong>Remarks:</strong> {order.remarks}</p>}
          </div>

          <div className="col-md-6">
            <h6 className="fw-semibold text-primary">Supplier Info</h6>
            <p><strong>Name:</strong> {order.Supplier?.name || "N/A"}</p>
            <p><strong>Email:</strong> {order.Supplier?.email || "N/A"}</p>
            <p><strong>Phone:</strong> {order.Supplier?.phone || "N/A"}</p>
          </div>
        </div>

        {/* 🧮 Items Table */}
        <h6 className="fw-semibold text-primary mb-2">Order Items</h6>
        <div className="table-responsive mb-4">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Item Name</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Sell Price</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.item_name}</td>
                    <td>{item.quantity}</td>
                    <td>Rs. {Number(item.rate).toLocaleString()}</td>
                    <td>Rs. {Number(item.sellPrice).toLocaleString()}</td>
                    <td>Rs. {Number(item.amount).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No items found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 💸 Expenses Table */}
        <h6 className="fw-semibold text-primary mb-2">Additional Expenses</h6>
        <div className="table-responsive mb-4">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Expense Name</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {expenses.length > 0 ? (
                expenses.map((exp, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{exp.expense_name}</td>
                    <td>Rs. {Number(exp.expense_amount).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No expenses added
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 🧾 Totals Summary */}
        <div className="row justify-content-end">
          <div className="col-md-4">
            <table className="table table-sm">
              <tbody>
                <tr>
                  <td><strong>Items Total:</strong></td>
                  <td className="text-end">Rs. {totalItems.toLocaleString()}</td>
                </tr>
                <tr>
                  <td><strong>Expenses Total:</strong></td>
                  <td className="text-end">Rs. {totalExpenses.toLocaleString()}</td>
                </tr>
                <tr>
                  <td><strong>Grand Total:</strong></td>
                  <td className="text-end fw-bold text-success">
                    Rs. {grandTotal.toLocaleString()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* ⚙️ Actions */}
        <div className="mt-3 d-flex justify-content-end gap-2">
          <Link to={`/edit-purchase-order/${order.id}`} className="btn btn-warning">
            Edit
          </Link>
          <button onClick={handleConvertToBill} className="btn btn-primary">
            Convert to Bill
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewPurchaseOrderLayer;
